<template src="./index.html">
</template>

<script>
import {getdata} from './data.js'

export default {
  props: {
    manualAllocationDiag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formlist: getdata().formlist,
      formdata: getdata().formdata,
    }
  },
  created() {
  },
  methods: {
    closediag() {
      this.$emit("closeManualAllocationDiag");
    },
    initData(fentshuie) {
      this.formdata.fentshuie = fentshuie;
    },
    confirm() {
      this.$message.info("手工分摊税额确认");
      this.closediag();
    }
  }

}
</script>

<style>
</style>